import { createContext, useState } from "react";
export interface Notif {
    title?: string;
    message?: string;
    notifType: 'success' | 'error' | 'pending' | 'warning';
}
export interface AppNotificationContext {
    notif: Notif;
    show: boolean;
    setNotif: (notif:Notif) => void;
    showNotif: (notif:Notif | null) => void;
    clearNotif: () => void;
}
const initialNotifCtx: AppNotificationContext = {
    notif: {
        message: '',     
        notifType: 'success'
    },
    show: false,
    setNotif: () => {},
    clearNotif: () => {},
    showNotif: () => {},
}
const AppNotifCtx = createContext(initialNotifCtx);

export const NotifContextProvider = (props: any)  => {

    const [notification, setNotification] = useState<Notif>({
        message: '',    
        notifType: 'success'
    });
    const [showNotification, setShowNotification] = useState(false);

    const notifContext: AppNotificationContext = {
        notif: notification,
        show: showNotification,
        setNotif: (newNotif) => setNotification(newNotif),
        clearNotif: () => setShowNotification(false),
        showNotif: (newNotif) => {
            newNotif && setNotification(newNotif);
            setShowNotification(true);
        },
    }

    

    return (<AppNotifCtx.Provider value={notifContext}>
        {props.children}
    </AppNotifCtx.Provider> );


}



export default AppNotifCtx;